/* eslint-disable no-underscore-dangle */

import design from '../models/design';

function defaultProperties() {
    return {
        designs: [],
    };
}

function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function fromJSON(json) {
    if (!json) {
        return null;
    }

    return {
        designs: json._embedded.designs.map(design.fromJSON),
        designPageUrls: json._links.designPageUrls
            ? json._links.designPageUrls.map(link => link.href)
            : [],
        currentPageUrl: json._links.currentPageUrl ? json._links.currentPageUrl.href : undefined,
        designPageOffset: json.designPageOffset,
        totalDesignCount: json.totalDesignCount,
    };
}

export default {
    create,
    defaultProperties,
    fromJSON,
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/models/designCollection.js